import React, { useState, useEffect, useContext } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { FacebookShareButton, FacebookIcon } from "react-share";
import { CopyToClipboard } from "react-copy-to-clipboard";
import lodash from "lodash";
import { isMobile } from "react-device-detect";
import Api from "../../../helpers/Api";
import { useTranslation, initReactI18next } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faSearch,
  faShareAlt,
  faShareAltSquare,
} from "@fortawesome/free-solid-svg-icons";

import {
  DonorNameWrapper,
  DonorName,
  BubbleTriangle,
  Overlay,
  ModalApp,
} from "./styles.js";

import "./style.css";

import { logResponse } from "../../../helpers/Logger";
import { reducer } from "../../../context";

import { Link } from "react-router-dom";

import Autocomplete from "react-autocomplete";
import { Col, Row, InputGroup } from "react-bootstrap";
import ReactTooltip from "react-tooltip";

const matrixSide = 32;
const matrixSize = matrixSide * matrixSide;

interface Props extends RouteComponentProps {}

var imageLength = 1024;
var dotLength = imageLength / matrixSide;

var resetDot = false;

const checkActive = (section: any[][], line: number) => {
  section = lodash.flatten(section);
  let donated = 0;
  lodash.forEach(section, (record) => {
    if (!lodash.isEmpty(record)) {
      donated++;
    }
  });
  if (donated >= line) {
    return true;
  } else {
    return false;
  }
};

const Pixel = ({
  onClick,
  onHover,
  onChangeColor,
  opacity,
  donorName,
  showDonor,
  isOwner,
  id,
  dotSize,
}: {
  onClick?: (event?: any) => void;
  onHover?: (event: boolean) => void;
  onChangeColor?: (event?: any) => void;
  opacity: number;
  donorName?: string;
  showDonor?: boolean;
  isOwner?: boolean;
  id?: string;
  dotSize?: number;
}) => {
  const [isOwnerVal, setIsOwner] = useState(isOwner);

  return (
    <DonorNameWrapper
      className="donorName"
      showDonor={showDonor}
      opacity={opacity}
      width={dotSize}
      height={dotSize}
    >
      {/* <DonorName className="donorName" isOwner={isOwner} showDonor={showDonor} id={`${id}1`}>
                {donorName || "No Donor Name"}
            </DonorName> */}
      {/* <BubbleTriangle className="donorName" isOwner={isOwner} showDonor={showDonor} id={`${id}2`}/> */}
      <div
        style={{
          // position: "absolute",
          overflow: "hidden",
          width: dotSize,
          height: dotSize,
        }}
        id={id + "_outter"}
        onClick={onClick}
      >
        <div
          id={id}
          style={{
            borderRadius: "100%",
            width: dotSize,
            height: dotSize,
            boxShadow: "0px 0px 0px 8px #FFFFFF",
            backgroundColor: isOwnerVal ? "orange" : null,
            opacity: isOwnerVal ? 1 : null,
          }}
        />
      </div>
    </DonorNameWrapper>
  );
};

const Line = ({ isRow, pixels }: { isRow: boolean; pixels: any[] }) => (
  <div style={{ display: "flex", flexDirection: isRow ? "row" : "column" }}>
    {pixels}
  </div>
);

var lastDot;
var setLastDot = (lastDot_arg) => {
  lastDot = lastDot_arg;
  resetDot = false;
};
var imagePositionLookup = {};

const DonorImage: React.FunctionComponent<Props> = (props) => {
  const { configReducer } = useContext(reducer);
  const { project, version, index } = props.match.params as {
    [key: string]: any;
  };
  const [donorRecords, setDonorRecords] = useState<any[]>([]);
  const [finishFetch, setFinishFetch] = useState(false);
  const [componentMatrix, setComponentMatrix] = useState<any[]>([]);
  const [showDonor, setShowDonor] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedDonor, setSelectedDonor] = useState("");
  const [selectACData, setSelectACData] = useState<any[]>();
  const [donationData, setDonationData] = useState<any[]>();
  const [acValue, setAcValue] = useState("");

  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const [isTooltip, setTooltip] = useState(false);

  const { t } = useTranslation();

  var imageLength = Math.min(window.innerWidth * 0.99, 1024); //* 0.95

  imageLength = Math.floor(imageLength / 32) * 32; // only get a multiply of 32
  var dotLength = imageLength / 32;
  console.log("======== Resize =========");
  console.log(imageLength);
  console.log(dotLength);

  const [imageSize, setImageSize] = React.useState({
    imageLength: imageLength,
    dotLength: dotLength,
  });

  React.useEffect(() => {
    function handleResize() {
      var imageLength = Math.min(window.innerWidth * 0.99, 1024); //* 0.9

      imageLength = Math.floor(imageLength / 32) * 32; // only get a multiply of 32
      var dotLength = imageLength / 32;

      console.log("======== Resize =========");
      console.log(imageLength);
      console.log(dotLength);

      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
      setImageSize({
        imageLength: imageLength,
        dotLength: dotLength,
      });
    }

    //  window.addEventListener("resize", handleResize);
  });

  useEffect(() => {
    setSelectACData([]);
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
    };
    fetch(`${Api.path(window.location)}/donate/queryConfirmedGeneralDonation`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        projectId: project,
        projectImageVer: version,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((resJson) => {
        const { data, msg } = resJson;
        logResponse(
          configReducer.state.debugMode,
          `donate/queryConfirmedGeneralDonation: ${msg}`
        );
        if (msg == "OK") {
          setDonorRecords(
            lodash.orderBy(data.dataList, ["projectImageVerPosition"], ["asc"])
          );
          setDonationData(data.dataList);
          var autocompleteData = data.dataList
            .map((data) => {
              //console.info(data.projectImageVerPosition);
              //console.info(data);
              //data.projectImageVerPosition
              //data.nameplate.tributeName
              return {
                index: data.projectImageVerPosition,
                label: data.nameplate.tributeName,
                id: data.projectImageVerPosition,
              };
            })
            .filter((elm) => elm.label);
          console.info(autocompleteData);
          setSelectACData(autocompleteData);
        } else {
          setDonorRecords([]);
          setSelectACData([]);
        }
        setFinishFetch(true);
      });
  }, [configReducer.state.debugMode, project, version]);

  const renderOverlay = (
    selectedDonor: string,
    donationData,
    onClick?: () => void,
    fbshareQuote?: string,
    fbshareHash?: string
  ) => {
    var donationList = donationData.filter((elm) => {
      return elm.nameplate.tributeName == selectedDonor;
    });

    var donation = null;
    if (donationList.length > 0) {
      donation = donationList[0];
    }

    var url = window.location.href;
    if (donation) {
      url =
        "https://support.westkowloon.hk/donation/auth/donation/map/" +
        donation.projectId +
        "/" +
        donation.projectImageVer +
        "/" +
        donation.projectImageVerPosition;
    }

    return (
      <Overlay onClick={onClick}>
        <ModalApp>
          <p style={{ textAlign: "center" }}>{selectedDonor}</p>

          <p style={{ textAlign: "center" }}>
            <input value={url} readOnly size={50} style={{ width: "100%" }} />
          </p>
          <p style={{ textAlign: "center" }} className="shareIconContainer">
            <span>
              <FacebookShareButton
                url={url}
                quote={fbshareQuote}
                hashtag={fbshareHash}

                // fbshareQuote:"",
                // fbshareHash:"",
              >
                <FacebookIcon size={32} round={true} />
              </FacebookShareButton>
            </span>
            <span>
              <CopyToClipboard text={url} onCopy={() => setTooltip(true)}>
                <FontAwesomeIcon
                  icon={faShareAltSquare}
                  size="2x"
                  style={{ cursor: "pointer" }}
                />
              </CopyToClipboard>
              {isTooltip ? <p>{t("Copied")}</p> : null}
            </span>
          </p>
        </ModalApp>
      </Overlay>
    );
  };

  useEffect(() => {
    if (!finishFetch) {
      return;
    }
    const allDots = new Array(matrixSize);
    lodash.fill(allDots, {});

    lodash.forEach(donorRecords, (record, index) => {
      allDots[index] = { ...record, index: index + 1 };
    });

    lodash.reverse(allDots);
    const columns = lodash.chunk(allDots, 32); //chunk to column
    lodash.forEach(columns, (column) => lodash.reverse(column)); //reverse the record in column
    const matrix: any[][][] = lodash.chunk(columns, 8);
    lodash.forEach(matrix, (columns) => lodash.reverse(columns)); //reverse the column in columns
    lodash.reverse(matrix);

    const sections = {
      A: {
        active: true,
        section: matrix[0],
      },
      B: {
        active: checkActive(matrix[0], 8 * 32 * 0.8),
        section: matrix[1],
      },
      C: {
        active: checkActive(matrix[1], 8 * 32 * 0.8),
        section: matrix[2],
      },
      D: {
        active: checkActive(matrix[2], 8 * 32 * 0.8),
        section: matrix[3],
      },
    };

    const arr2: JSX.Element[] = [];

    lodash.forEach(sections, (sectionItem, key) => {
      const { active, section } = sectionItem;

      lodash.forEach(section, (column, columnIndex) => {
        var arr: JSX.Element[] = [];
        lodash.forEach(column, (point, pointIndex) => {
          if (active) {
            if (lodash.isEmpty(point)) {
              arr.push(
                <Pixel
                  key={`${columnIndex}point${pointIndex}`}
                  opacity={0.7}
                  showDonor={false}
                  dotSize={imageSize.dotLength}
                />
              );
            } else {
              const { nameplate } = point;

              if (point.projectImageVerPosition == index) {
                //do the initial module dialog if we match
                setShowModal(true);
                setSelectedDonor(nameplate.tributeName || "Anonymous");
                setLastDot(`${point.projectImageVerPosition}`);
              }

              arr.push(
                <Pixel
                  // id={`${columnIndex}point${pointIndex}`}
                  id={`${point.projectImageVerPosition}`}
                  key={`${columnIndex}point${pointIndex}`}
                  opacity={0}
                  onChangeColor={(color) => {}}
                  onClick={(e) => {
                    // const name: HTMLElement = document.getElementById(`${columnIndex}point${pointIndex}1`);
                    // const tri: HTMLElement = document.getElementById(`${columnIndex}point${pointIndex}2`);
                    // if(showDonor == `${columnIndex}point${pointIndex}`) {
                    //     setShowDonor(``)
                    //     name.style.display = 'block';
                    //     tri.style.display = 'block';
                    // } else {
                    //     setShowDonor(`${columnIndex}point${pointIndex}`)
                    //     name.style.display = 'none';
                    //     tri.style.display = 'none';
                    // }

                    if (resetDot) {
                      return;
                    }
                    resetDot = true;
                    setShowModal(true);
                    setSelectedDonor(nameplate.tributeName || "Anonymous");

                    //lastDot;

                    let dom = document.getElementById(lastDot);
                    if (dom) dom.style.backgroundColor = null;
                    let dom_outter = document.getElementById(
                      lastDot + "_outter"
                    );
                    if (dom_outter) dom_outter.style.backgroundColor = null;

                    e.target.style.backgroundColor = "orange";

                    console.log("To new Dot");
                    console.log(lastDot);
                    console.log(`${point.projectImageVerPosition}`);
                    //setLastDot(columnIndex + "point" + pointIndex);
                    setLastDot(`${point.projectImageVerPosition}`);

                    //e.target.changeColor = "orange";
                  }}
                  isOwner={point.projectImageVerPosition == index}
                  donorName={nameplate.tributeName}
                  dotSize={imageSize.dotLength}
                />
              );
            }
          } else {
            arr.push(
              <Pixel
                key={`${columnIndex}point${pointIndex}`}
                opacity={0.7}
                showDonor={false}
                dotSize={imageSize.dotLength}
              />
            );
          }
        });

        arr2.push(
          <Line key={`${key}column${columnIndex}`} isRow={false} pixels={arr} />
        );
      });
    });
    setComponentMatrix(arr2);
  }, [donorRecords, finishFetch, imageSize.dotLength, index, showDonor]);
  const imagePath = "/donation/assets/icons/dotdotimage.png";
  //const imagePath = '/assets/icons/dotdotimage.png';
  const wrapper = (children: any) =>
    isMobile ? (
      <div
        style={{
          backgroundColor: "#2c3e50",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {children}
      </div>
    ) : (
      children
    );
  return wrapper(
    <div
      style={{
        width: "100%",
        paddingTop: 100,
        paddingBottom: 100,
        backgroundColor: "#2c3e50",
        display: "flex",
        flexDirection: "column",
        ...(isMobile
          ? {
              overflowX: "scroll",
              width: "96%",
            }
          : {
              alignItems: "center",
              justifyContent: "center",
            }),
      }}
    >
      <h1 style={{ color: "white" }}>{t("ackPageHeading")}</h1>
      <h3 style={{ color: "white" }}>{t("ackTagline")}</h3>

      <Row
        className="justify-content-lg-center c4_width_set"
        style={
          {
            /* width: "100%" */
          }
        }
      >
        <Col xs={0} lg="3"></Col>
        <Col xs="12" lg="6">
          <InputGroup>
            <InputGroup.Prepend className="">
              <InputGroup.Text
                id="basic-addon1"
                style={{
                  height: "40px",
                  width: "40px",
                  backgroundColor: "white",
                  borderRight: "0px",
                }}
              >
                <FontAwesomeIcon
                  icon={faSearch}
                  style={{ position: "absolute", left: "12px" }}
                />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Autocomplete
              renderInput={(p) => {
                return (
                  <input
                    {...p}
                    style={{
                      display: "inline",
                      /* width: "100%"*/ borderLeft: "0px",
                      height: "40px",
                      borderTopLeftRadius: "unset",
                      borderBottomLeftRadius: "unset",
                    }}
                    className="form-control c4-form-control"
                  />
                );
              }}
              getItemValue={(item) => item.label}
              items={selectACData}
              wrapperProps={{ className: "col" }}
              wrapperStyle={{ padding: 0 }}
              renderItem={(item, isHighlighted) => (
                <div
                  style={{
                    background: isHighlighted ? "lightgray" : "white",
                  }}
                  key={item.id}
                >
                  {item.label}
                </div>
              )}
              value={acValue}
              shouldItemRender={(item, value) => {
                if (value.length <= 0) {
                  return false;
                }
                var arr = item.label.toLowerCase().split(" ");

                //          console.log(arr);
                return (
                  arr &&
                  arr.filter((e) => {
                    return e.startsWith(value.toLowerCase());
                  }).length !== 0
                );
                //          item.label.toLowerCase().indexOf(value.toLowerCase()) > -1 &&
                //return true;
              }}
              onChange={(e) => {
                setAcValue(e.target.value);
                return e.target.value;
              }}
              onSelect={(val) => {
                console.info(val);

                console.info(donationData);

                var donation = donationData.filter(
                  (elm) => elm.nameplate.tributeName == val
                );

                var d = null;
                if (donation.length > 0) {
                  d = donation[0];
                  setSelectedDonor(d.nameplate.tributeName || "Anonymous");
                  setShowModal(true);
                }
                setAcValue(val);

                let dom = document.getElementById(lastDot);
                if (dom) dom.style.backgroundColor = null;
                if (d) {
                  var dot = document.getElementById(d.projectImageVerPosition);
                  dot.style.backgroundColor = "orange";
                  setLastDot(d.projectImageVerPosition);
                }

                return val;
              }}
              menuStyle={{
                borderRadius: "3px",
                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                background: "rgba(255, 255, 255, 0.9)",
                padding: "2px 0",
                fontSize: "90%",
                position: "absolute",
                overflow: "auto",
                maxHeight: "50%", // TODO: don't cheat, let it flow to the bottom
                zIndex: "99",
              }}
              renderMenu={(items, value, style) => {
                console.log(value);

                if (!value) {
                  return <div style={{ display: "none" }}></div>;
                }
                return (
                  <div
                    style={{
                      ...style,
                      borderRadius: "3px",
                      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                      background: "rgba(255, 255, 255, 0.9)",
                      padding: "2px 0",
                      fontSize: "90%",
                      position: "fixed",
                      overflow: "auto",
                      maxHeight: "50%",
                      zIndex: "99",
                    }}
                    children={items}
                  />
                );
              }}
            />
          </InputGroup>
        </Col>
        <Col md="3" xs={0} lg="3"></Col>
      </Row>
      {showModal &&
        renderOverlay(
          selectedDonor,
          donationData,
          () => {
            //setShowModal(false);
          },
          t("fbshareQuote"),
          t("fbshareHash")
        )}
      {/*
ackPageHeading: "鸣谢",
      ackTagline: "感谢以下支持者对我们慷慨的捐助", */}
      <div style={{ margin: "0 auto" }}>
        <div
          style={{
            backgroundImage: `url(${imagePath})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            textAlign: "center",
            flexDirection: "row",
            display: "flex",
            width: `${imageSize.imageLength}px`,
            height: `${imageSize.imageLength}px`,
            padding: "0px",
          }}
        >
          {componentMatrix}
        </div>
      </div>

      <div style={{ color: "white", padding: "20px" }}>
        {t("ackLink_1_1")} {t("ackLink_1_2")}&nbsp;
        {/* <a target="_self" href={ t("ackLink_link") }>{ t("ackLink_2") }</a> */}
        <span
          role="link"
          onClick={() => {
            window.location.href = t("ackLink_link");
          }}
        >
          {t("ackLink_2")}
        </span>
        {t("ackLink_3")}
      </div>

      {/*
      <div style={{ marginTop: 30 }}>
        <FacebookShareButton url={window.location.href} quote="" title="">
          <img
            className="share-btn-icon"
            src="/donation/assets/icons/share_fb_white.png"
            alt="share_facebook"
          />
        </FacebookShareButton>
      </div>
*/}
    </div>
  );
};

export default withRouter(DonorImage);
